import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type ProductFile = {
  product_file_id?: number; // 상품 파일 idx
  product_id?: number; // 상품 idx
  file_name?: string; // 파일명
  file_url?: string; // 파일 URL
  type?: string; // 파일 타입
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] ProductFile
   * --
   */
  getProductFiles: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PRODUCT_FILE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] ProductFile
   * --
   */
  getProductFile: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PRODUCT_FILE, {
        product_file_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ProductFile
   * --
   */
  createProductFile: async (body: ProductFile) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PRODUCT_FILE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] ProductFile
   * --
   */
  updateProductFile: async (body: ProductFile) => {
    try {
      const { product_file_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PRODUCT_FILE, {
        product_file_id: product_file_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] ProductFile
   * --
   */
  deleteProductFile: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_PRODUCT_FILE, {
        product_file_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
